"use client";

import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import Sidebar from "@/components/layout/Sidebar";
import MainContent from "@/components/layout/MainContent";
import ShellSidebarRouteSync from "@/components/layout/ShellSidebarRouteSync";
import {
  isAiCoinLabPath,
  isSupportWidgetPath,
  isTelegramBotPath,
} from "@/lib/layout/shellSidebarRoutes";

const SupportButton = dynamic(
  () => import("@/components/common/SupportButton"),
  { ssr: false },
);

/** App shell chrome loaded after the main route bundle to cut unused JS on landing pages. */
export default function AppChrome({ children }) {
  const pathnameHook = usePathname();
  const pathname =
    pathnameHook ||
    (typeof window !== "undefined" ? window.location.pathname : "");

  const aiCoinLab =
    isAiCoinLabPath(pathname) ||
    (typeof pathname === "string" && pathname.includes("/ai/coin-lab"));

  const hideSiteChrome =
    isTelegramBotPath(pathname) || isSupportWidgetPath(pathname) || aiCoinLab;

  if (hideSiteChrome) {
    const shellClass = isSupportWidgetPath(pathname)
      ? "flex h-dvh max-h-dvh min-h-0 min-w-0 max-w-full flex-col overflow-hidden bg-transparent"
      : aiCoinLab
        ? "flex h-dvh max-h-dvh min-h-0 min-w-0 max-w-full flex-col overflow-hidden bg-black"
        : "flex h-dvh max-h-dvh min-h-0 min-w-0 max-w-full flex-col overflow-hidden bg-idx-canvas";
    return <div className={shellClass}>{children}</div>;
  }

  return (
    <>
      <ShellSidebarRouteSync />
      <Sidebar />
      <MainContent>
        {children}
        <SupportButton />
      </MainContent>
    </>
  );
}
